import axios from "axios";
import store from "./store";
import wx from 'weixin-js-sdk'

let wxFn = (url) => {
    axios({
        // url: 'http://syg-tx.yuntuys.com/api/wxmp/getJsSDKSign?url=' + url,
        url: '/wxmp/getJsSDKSign?url=' + url,
        // baseURL: '',
        method: 'get'
    }).then((res)=>{
        // console.log(res.data.data)
        store.commit('setwxConfigData', res.data.data);
        wx.config({
            debug: false,
            appId: res.data.data.appId,
            // appId: 'wx2e701f9c5805f5df',
            timestamp:  res.data.data.timestamp,
            nonceStr: res.data.data.nonceStr,
            signature: res.data.data.signature,
            jsApiList:[
                'updateTimelineShareData',
                'hideMenuItems',
                'updateAppMessageShareData'
            ]
        });
    })
}

export default wxFn

